/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCompanyRoleSettings200ResponsePermissionsInner } from './GetCompanyRoleSettings200ResponsePermissionsInner';
import {
    GetCompanyRoleSettings200ResponsePermissionsInnerFromJSON,
    GetCompanyRoleSettings200ResponsePermissionsInnerFromJSONTyped,
    GetCompanyRoleSettings200ResponsePermissionsInnerToJSON,
} from './GetCompanyRoleSettings200ResponsePermissionsInner';

/**
 * 
 * @export
 * @interface GetAccountRoles200Response
 */
export interface GetAccountRoles200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetAccountRoles200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetAccountRoles200Response
     */
    message: string;
    /**
     * `権限コード`
     * @type {string}
     * @memberof GetAccountRoles200Response
     */
    roleCode: string;
    /**
     * `権限名`
     * @type {string}
     * @memberof GetAccountRoles200Response
     */
    roleName: string;
    /**
     * 企業タイプ 0:一般 1:運営
     * @type {number}
     * @memberof GetAccountRoles200Response
     */
    companyType: number;
    /**
     * 管理者フラグ
     * 企業設定などで使用
     * @type {boolean}
     * @memberof GetAccountRoles200Response
     */
    isAdmin: boolean;
    /**
     * `許可設定`
     * @type {Array<GetCompanyRoleSettings200ResponsePermissionsInner>}
     * @memberof GetAccountRoles200Response
     */
    permissions: Array<GetCompanyRoleSettings200ResponsePermissionsInner>;
}

/**
 * Check if a given object implements the GetAccountRoles200Response interface.
 */
export function instanceOfGetAccountRoles200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "roleCode" in value;
    isInstance = isInstance && "roleName" in value;
    isInstance = isInstance && "companyType" in value;
    isInstance = isInstance && "isAdmin" in value;
    isInstance = isInstance && "permissions" in value;

    return isInstance;
}

export function GetAccountRoles200ResponseFromJSON(json: any): GetAccountRoles200Response {
    return GetAccountRoles200ResponseFromJSONTyped(json, false);
}

export function GetAccountRoles200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountRoles200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'roleCode': json['role_code'],
        'roleName': json['role_name'],
        'companyType': json['company_type'],
        'isAdmin': json['is_admin'],
        'permissions': ((json['permissions'] as Array<any>).map(GetCompanyRoleSettings200ResponsePermissionsInnerFromJSON)),
    };
}

export function GetAccountRoles200ResponseToJSON(value?: GetAccountRoles200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'role_code': value.roleCode,
        'role_name': value.roleName,
        'company_type': value.companyType,
        'is_admin': value.isAdmin,
        'permissions': ((value.permissions as Array<any>).map(GetCompanyRoleSettings200ResponsePermissionsInnerToJSON)),
    };
}

